export function throttleAsync<Func extends AnyFunction>(func: Func, delay = 0) {
	let timeout = 0
	let isBusy = false
	let nextArgs: Parameters<Func> | null = null

	const nextRun = () => {
		timeout = 0
		run()
	}

	const run = async () => {
		if (isBusy || !nextArgs) {
			return
		}

		if (timeout) {
			// Delay next runs only.
			window.clearTimeout(timeout)
			timeout = window.setTimeout(nextRun, delay)
			return
		}

		const args = nextArgs

		nextArgs = null
		isBusy = true

		await func(...args)

		isBusy = false
		timeout = window.setTimeout(nextRun, delay)
	}

	return function (...args: Parameters<Func>) {
		nextArgs = args
		// First run should be instant
		run()
	}
}

export function throttle(func: (...args: any[]) => void | Promise<void>, interval = 0) {
	let busy = false

	return function (this: any, ...args: any[]) {
		if (busy) {
			return
		}

		busy = true

		globalThis.setTimeout(async () => {
			try {
				const result = func.apply(this, args)
				if (result instanceof Promise) await result
			} finally {
				busy = false
			}
		}, interval) as unknown as number
	}
}

export function throttled(interval = 0) {
	return function (_target: any, _propertyKey: string, descriptor: PropertyDescriptor) {
		descriptor.value = throttle(descriptor.value, interval)
	}
}
